var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon52(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3144_77614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9498 4.59101C8.97664 4.59327 8.02735 4.29822 7.23602 3.74753V7.58819C7.23575 8.29952 7.01211 8.99382 6.595 9.57825C6.17789 10.1627 5.5872 10.6094 4.9019 10.8586C4.2166 11.1079 3.46937 11.1478 2.76011 10.973C2.05086 10.7982 1.41339 10.4171 0.932946 9.88063C0.452501 9.34413 0.151982 8.67782 0.0715716 7.9708C-0.00883868 7.26378 0.134693 6.54974 0.482974 5.92416C0.831255 5.29858 1.36768 4.79128 2.02054 4.4701C2.67339 4.14891 3.41154 4.02915 4.13629 4.12683V6.05855C3.80464 5.95713 3.44851 5.96018 3.11876 6.06727C2.789 6.17437 2.50248 6.38002 2.30012 6.65486C2.09776 6.9297 1.9899 7.25968 1.99195 7.59767C1.994 7.93566 2.10585 8.26438 2.31152 8.53689C2.5172 8.8094 2.80619 9.01175 3.13722 9.11506C3.46825 9.21837 3.82439 9.21734 4.15479 9.11213C4.48519 9.00693 4.77294 8.80291 4.97696 8.52923C5.18097 8.25555 5.29082 7.92619 5.29081 7.58819V0.0800781H7.23602C7.23467 0.239778 7.24843 0.399259 7.27713 0.556507C7.34473 0.907539 7.48527 1.24148 7.69017 1.53789C7.89507 1.8343 8.16001 2.08697 8.46879 2.28042C8.9081 2.56282 9.42315 2.71333 9.9498 2.71323V4.59101Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3144_77614",
    x: 0.0498047,
    y: 0.0800781,
    width: 9.90039,
    height: 13,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3144_77614"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon52);
export default __webpack_public_path__ + "static/media/icon52.33742d3322dc1378888b98acf7170318.svg";
export { ForwardRef as ReactComponent };